<template>
  <div class="appointment-list-card card-style">
    <h3 class="section-title">📅 Upcoming Appointments ({{ appointments.length }})</h3>
    
    <div v-if="loading" class="loading-msg">Loading appointments...</div>
    <div v-else-if="error" class="error-msg">Error fetching appointments: {{ error }}</div>
    <div v-else-if="appointments.length === 0" class="no-appointments-msg">
      No upcoming appointments currently scheduled.
    </div>

    <ul v-else class="appointment-list">
      <li 
        v-for="appointment in appointments" 
        :key="appointment.id" 
        class="appointment-item"
      >
        <div class="info-details">
          <span class="appointment-date-time">
            {{ formatDateTime(appointment.start_time) }}
          </span>
          <span class="appointment-service">
            **Service:** {{ appointment.service_name }}
          </span>
          <span class="appointment-stylist">
            **Stylist:** {{ appointment.stylist_name }}
          </span>
        </div>
        <div class="client-info">
            Client: {{ appointment.client_name }}
        </div>
      </li>
    </ul>

  </div>
</template>

<script>

import axios from 'axios'
const API_BASE_URL = 'https://api-afrobraids.inchtechs.com/api/';

export default {
    name: 'AppointmentList',
    data() {
        return {
            appointments: [],
            loading: true,
            error: null,
        }
    },
    created() {
        this.fetchAppointments();
    },
    methods: {
        async fetchAppointments() {
            this.loading = true;
            this.error = null;
            console.log("Here fetchub")
            try {
                const response = await axios.get(`${API_BASE_URL}appointment/get`);
                
                this.appointments = (response.data || []).map(app => ({
                    appointment_id: app.appointment_id,
                    appointment_status: app.appointment_status, 
                    created_at: app.appointment_created_at,
                    google_event_id: app.google_event_id,
                    client_name: app.client_name,
                    client_email: app.client_email,
                    service_name: app.service_name,
                    stylist_name: app.stylist_name,
                    start_time: app.start_time,
                    end_time: app.end_time,
                    date: app.date // ISO format
                }));
            } catch (err) {
                const dbError = err.response?.data?.error;
                const dbType = err.response?.data?.type;
                
                console.error(`--- BACKEND CRASH [${dbType}] ---`);
                console.error(dbError); 

                this.error = dbError || err.message;
            } finally {
                this.loading = false;
            }
            this.sortAppointmentbyDate()
        },
        formatDateTime(isoString) {
            if (!isoString) return 'N/A';
            const date = new Date(isoString);
            return date.toLocaleString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        sortAppointmentbyDate() {
            this.appointments.sort((a, b) => {
                const dateA = new Date(a.start_time)
                const dateB = new Date(b.start_time)

                return dateB.getTime() - dateA.getTime()
            })
            console.log("Appointments have been sorted")
        }
    }
}
</script>

<style scoped>
/* Scoped styles for the Appointment List component */
.appointment-list-card {
    /* Inherits card-style from parent dashboard CSS */
    min-height: 300px;
}

.loading-msg, .error-msg, .no-appointments-msg {
    text-align: center;
    padding: 20px 0;
    color: #888;
}
.error-msg {
    color: var(--color-maroon);
    font-weight: 600;
}

.appointment-list {
    list-style: none;
    padding: 0;
}

.appointment-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
    margin-bottom: 8px;
    border: 1px solid #eee;
    border-left: 4px solid var(--color-gold); /* Gold accent */
    border-radius: 6px;
    background-color: var(--color-light);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.info-details {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.appointment-date-time {
    font-weight: bold;
    color: var(--color-dark);
    font-size: 1.1rem;
}

.appointment-service, .appointment-stylist {
    font-size: 0.9rem;
    color: #555;
}

.client-info {
    font-weight: 600;
    color: var(--color-maroon);
    text-align: right;
    font-size: 1rem;
}
</style>